import React, {Component} from "react";
import axios from "axios";
import {AuthenticationContext} from "cw-styleguide-react";


const withAuditApi = env => WrappedComponent => {
  return class withAuditApiHOC extends Component {

    // Add the context to the class.
    static contextType = AuthenticationContext;

    // Define the API endpoints and their fallbacks.
    audit_api_audit = env.REACT_APP_AUDIT_API_AUDIT || env.REACT_APP_ENV + '/audit-api/api/v1/audit';

    /**
     * constructor.
     * @param props
     */
    constructor(props) {
      super(props);
      this.auditApiGetEndpoint = this.auditApiGetEndpoint.bind(this);
      this.auditApiGetAudit = this.auditApiGetAudit.bind(this);
    }

    /**
     * addressFinderApiGetEndpoint
     * @param endpoint
     * @returns {*}
     */
    auditApiGetEndpoint(endpoint) {
      return this[endpoint];
    }

    /**
     * auditApiGetAudit
     * @param id
     * @param language
     * @param successCallback
     * @param errorCallback
     */
    auditApiGetAudit(id, type, language, successCallback, errorCallback) {
      this.context.callWithToken(token => {
        axios.get(this.audit_api_audit, {
          headers: {
            'Authorization': 'Bearer ' + token,
            'content-type': 'application/json',
            'Accept-Language': language,
          },
          params: {
            id: id,
            type: type
          }
        }).then(response => {
          successCallback(response);
        })
          .catch(error => {
            errorCallback(error);
          });
      });
    }

    /**
     * Render.
     * @returns {JSX.Element}
     */
    render() {
      return (
          <WrappedComponent  {...this.props}
                             auditApiGetEndpoint={this.auditApiGetEndpoint}
                             auditApiGetAudit={this.auditApiGetAudit}
                         
          />
      );
    }

  }
}

export default withAuditApi;